import React from "react";
import styled from "styled-components";
import theme from "../../../styles/theme";
import headingStyles from "./headingStyles";

const {
	font,
	breakPoints: { mobileFirstScreenQuery },
} = theme;

const H4 = styled.h4(
	headingStyles,
	`
  font-family: ${font.semiBold};
  font-size: 18px;
  line-height: 22px;
  ${mobileFirstScreenQuery.medium}{
    font-size: 20px;
    line-height: 24px;
  }
`
);
export default ({ children, ...props }) => <H4 {...props}>{children}</H4>;
